<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }}</h5>
</div>
<div class="modal-body">
  <form [formGroup]="menuForm">
    <div class="row">
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
            <mdb-select formControlName="selectedCompanies" (valueChange)="onCompanySelectedTabMenu($event)">
              <mdb-option *ngFor="let company of AllCompaniesAndApps" [value]="company.ID">{{ company.NAME }}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleccione una Compañia</label>
          </mdb-form-control>
        </div>
      </div>
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
            <mdb-select formControlName="selectedApps">
              <mdb-option *ngFor="let app of CompanySelected.APPS" [value]="app.ID_APP">{{ app.NAME_APP }}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleccione una Aplicación</label>
          </mdb-form-control>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
              <input 
                  mdbValidate 
                  mdbInput type="text" 
                  id="menuName-input" 
                  class="form-control"
                  formControlName="menuName" 
                  required 
                  minlength="5" />
              <label mdbLabel class="form-label" for="menuName-input">Nombre del Menu (mínimo 5 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
              <input 
                  mdbValidate 
                  mdbInput type="text" 
                  id="pathName-input" 
                  class="form-control"
                  formControlName="pathName" 
                  required 
                  minlength="15" />
              <label mdbLabel class="form-label" for="pathName-input">Ruta del Menu (mínimo 15 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
              <input 
                  mdbValidate 
                  mdbInput type="text" 
                  id="routesConfigPath-input" 
                  class="form-control"
                  formControlName="routesConfigPath" 
                  required 
                  minlength="5" />
              <label mdbLabel class="form-label" for="routesConfigPath-input">ROUTES_CONFIG_PATH (mínimo 5 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
            <input 
                mdbValidate 
                mdbInput type="text" 
                id="routesConfigModulePath-input" 
                class="form-control"
                formControlName="routesConfigModulePath" 
                required 
                minlength="15" />
            <label mdbLabel class="form-label" for="routesConfigModulePath-input">ROUTES_CONFIG_MODULE_PATH (mínimo 15 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
            <input 
                mdbValidate 
                mdbInput type="text" 
                id="routesConfigModuleName-input" 
                class="form-control"
                formControlName="routesConfigModuleName" 
                required 
                minlength="5" />
            <label mdbLabel class="form-label" for="routesConfigModuleName-input">ROUTES_CONFIG_MODULE_NAME (mínimo 5 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control>
            <input 
                mdbValidate 
                mdbInput type="text" 
                id="routesConfigComponentName-input" 
                class="form-control"
                formControlName="routesConfigComponentName" 
                required 
                minlength="5" />
            <label mdbLabel class="form-label" for="routesConfigComponentName-input">ROUTES_CONFIG_COMPONENT_NAME (mínimo 5 caracteres) </label>
          </mdb-form-control>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="my-4 table-editor_input-wrapper">
          <div class="col-md-6">
            <mdb-file-upload
              #fileUpload
              [defaultPreview]="archivoMenu ? archivoMenu : null"
              [removeBtn] ="'Eliminar'"
              [defaultMsg]="'Seleccione Imagen del Menu'" 
              [previewMsg]="'Arrastre o haga click para seleccionar otro archivo'"
              [removeBtnDisabled]="true"
              (fileAdded)="onFileMenuAdded($event)">
            </mdb-file-upload>
          </div>
        </div>
      </div>
      {{activeMenu}}
      <div class="col my-4">
        <div class="form-check">
          <input
            mdbCheckbox
            class="form-check-input"
            type="checkbox"
            value=""
            id="active-checkbox"
            formControlName="activeMenu"
            (change)="onActiveMenuCheckboxChange($event)"
          />
          <label class="form-check-label" for="active-checkbox">
              Menu Activo?
          </label>
        </div>
        <div class="form-check" >
          <input
            mdbCheckbox
            class="form-check-input"
            type="checkbox"
            value=""
            id="isDynamicCheck"
            formControlName="isDynamicCheck"
          />
          <label class="form-check-label" for="isDynamicCheck" >
            Desea que sea dinámico ?
          </label>
        </div>
        <div class="form-check" >
          <input
            mdbCheckbox
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            formControlName="checkSubMenu"
            (change)="onCheckSubMenuChange($event)"
          />
          <label class="form-check-label" for="flexCheckDefault" >
            Desea que sea SubMenu ?
          </label>
        </div>
        <div class="my-4 table-editor_input-wrapper">
          <mdb-form-control *ngIf="checkSubMenu === 1">
            <mdb-select formControlName="selectedSubMenu">
              <mdb-option *ngFor="let option of AllChildrenMenus" [value]="option.ID">{{option.NAME}}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleccione un sub menu</label>
          </mdb-form-control>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
    <button type="button" class="shadow-0 btn btn-md btn-outline-primary" (click)="modalRefMenu.close()">
        Cancelar
    </button>
    <button 
      type="button"
      class="shadow-0 btn btn-md btn-primary"
      (click)="InsertOrUpdate()"
      [textContent]="edit === 0 ? 'Guardar' : 'Editar'"
      [disabled]="menuForm.invalid"
      >
    </button>
</div>

<mdb-loading [show]="loading" [fullscreen]="true">
  <div class="loading-spinner">
    <div class="spinner-border loading-icon" role="status"></div>
    <span class="loading-text">Cargando datos...</span>
  </div>
</mdb-loading>